import { render, staticRenderFns } from "./ChangePassword_dialog.vue?vue&type=template&id=4e58db9f&scoped=true"
import script from "./ChangePassword_dialog.vue?vue&type=script&lang=js"
export * from "./ChangePassword_dialog.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword_dialog.vue?vue&type=style&index=0&id=4e58db9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e58db9f",
  null
  
)

export default component.exports